import type React from 'react'

/** 4-directional move cursor icon — shown in the node-edit toolbar popup for select/move mode. */
export const NodeEditMoveIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M3.33333 6.00016L1.33333 8.00016L3.33333 10.0002" fill="currentColor" />
    <path d="M5.99999 3.3335L7.99999 1.3335L9.99999 3.3335" fill="currentColor" />
    <path d="M9.99999 12.6668L7.99999 14.6668L5.99999 12.6668" fill="currentColor" />
    <path d="M12.6667 6.00016L14.6667 8.00016L12.6667 10.0002" fill="currentColor" />
    <path
      d="M3.33333 10.0002L1.33333 8.00016L3.33333 6.00016M1.33333 8.00016H14.6667M9.99999 3.3335L7.99999 1.3335L5.99999 3.3335M7.99999 1.3335V14.6668M5.99999 12.6668L7.99999 14.6668L9.99999 12.6668M12.6667 10.0002L14.6667 8.00016L12.6667 6.00016"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
